import { createAsyncThunk } from "@reduxjs/toolkit";

import { AppState } from "@/redux/store/store";
import { getLayers } from "@/models";
import { fetchAuthToken } from "@/helpers/fetch-auth-token";

export const fetchPlaceLayers = createAsyncThunk(
  "places/fetchPlaceLayers",
  async (
    params: Partial<{ projectId: string; placesId: string; config: object }>,
    { rejectWithValue, getState }
  ) => {
    const { adapter } = getState() as AppState;
    const { token } = fetchAuthToken(getState());

    const { baseUrl } = adapter.adapter;
    const { projectId, placesId, config } = params;
    try {
      const response = await getLayers(
        token,
        baseUrl,
        projectId,
        placesId,
        {},
        config
      );

      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
